import { FormField } from './FormField';

export const CheckboxField = ({ name, title, className, onChange }: CheckboxFieldProps) => {
  return (
    <FormField name={name}
               title={title}
               type="checkbox"
               className={className}
               onChange={(ev) => onChange?.(ev.target.checked)} />
  );
};

interface CheckboxFieldProps {
  name: string;
  title?: string;
  className?: string;
  onChange?: (checked: boolean) => void;
}